export class Money {

	static possibleChange(value: number, bills: number = 50): number {
		if(!(value > 0) || !(bills > 0)) { // avoid invalid types
			return null;
		}

		let aux = 0;
		while (aux < value) {
			aux += bills;
		}
		return aux;
	}
}